import React, { useState } from "react";
import { toast } from "react-toastify";
import "./index.css";

export default function AppointmentTypeModal({ id, onSelect }) {
  const [selectedType, setSelectedType] = useState("");

  const handleContinue = () => {
    if (!selectedType) {
      toast.error("Please select appointment type", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    onSelect(selectedType);
    window.loadModal2(`#${id}`, "hide");
  };

  return (
    <div className="confirm-delete-wrapper register-medium">
      <div data-backdrop="static" className="modal fade appointment-type-modal" id={id} role="dialog">
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">

              <h3>Select Appointment Type</h3>

              <div className="appointment-card-wrapper">

                <div
                  className={`type-card ${selectedType === "medium_to_medium" ? "active" : ""}`}
                  onClick={() => setSelectedType("medium_to_medium")}
                >
                  <h4>Medium to Medium</h4>
              
                </div>

                <div
                  className={`type-card ${selectedType === "client_to_medium" ? "active" : ""}`}
                  onClick={() => setSelectedType("client_to_medium")}
                >
                  <h4>Medium to Client</h4>
             
                </div>

              </div>

              <div className="confirm-btn-box">
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                >
                  Cancel
                </div>

                <div
                  className="register-medium-confirnation"
                  onClick={handleContinue}
                >
                  Continue
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}